import { getExpire } from "./utils";

var storage = {
    set(key, value, ttl = 60 * 60) {
        if (value.length <= 0 ) {
            return false;
        }
        const expire = getExpire(ttl);
        const items = {
            value: value,
            expire:expire
        };
        localStorage.setItem(key,JSON.stringify(items));
    },
    get(key) {
        if (this.check(key)) {
            const items = JSON.parse( localStorage.getItem(key) );
            return items.value;
        }
    },
    remove(key) {
        localStorage.removeItem(key);
    },
    check(key) {
        let items = JSON.parse(localStorage.getItem(key));
        if (!items || items.value.length === 0) {
            return false;
        }
        let now = Date.parse(new Date()) / 1000;
  
        if (now > items.expire) {
            this.remove(key);
            return false;
        }
        return true;
    },
    clear() {
        localStorage.clear();
    },
    removeById(key, id) {
        if (this.check(key)) {
            let items = this.get(key);
            for (let i = 0; i < items.length;i++){
                if (items[i].id === id) {
                    items.splice(i, 1);
                }
            }
            this.set(key, items);
        }
    },
    removeByImei(key, code) {
        if (this.check(key)) {
            let items = this.get(key);
            for (let i = 0; i < items.length; i++){
                if (items[i].code === code) {
                    items.splice(i, 1);
                }
            }
            this.set(key, items);
        }
    },
    setById(key, id, data) {
        // set the data will update the expire 
        if (this.check(key)) {
            let items = this.get(key);
            for (let i = 0; i < items.length;i++){
                if (items[i].id === id ) {
                    items[i] = data;
                }
            }
            this.set(key, items);
        }
    },
    getById(key, id) {
        if (this.check(key)) {
            let items = this.get(key);
            for (let i = 0; i < items.length; i++){
                if (items[i].id === id) {
                    return items[i]
                }
            }
            return [];
        }
    },
    setByImei(key, code, data) {
        if (this.check(key)) {
            let items = this.get(key);
            for (let i = 0; i < items.length;i++){
                if (items[i].code === code ) {
                    items[i] = data;
                }
            }
            this.set(key, items);
        }
    },

    insert(key,data) {
        if (this.check(key)) {
            let items = this.get(key);
            items.unshift(data);
            this.set(key, items);
        }
    }
}

export default storage;